import axios from 'axios'

/**
 * 视频分享落地页取数(TAPD 1006913)
 *
 * ⚠️ 这个页面**不走全局 ApolloClient** —— 那个 client 指向 blog-backend
 * (src/common/ApolloClient.js,运行时从 nginx 注入 _http_server_uri_),
 * 而本页的数据在 pigeon。所以单独用 axios 打 pigeon 的 GraphQL,别动全局 client。
 *
 * 两个容易踩的点(2026-09-01 实测):
 *  1. pigeon 的 GraphQL **不在 /graphql**(那儿有 koa-jwt 站着,裸打必 401),
 *     而在 /${SECRET} 这个路径 —— 它在 koa-jwt 的 unless 名单里。这个值不是机密:
 *     App 的远程配置 configs.ihealthlabs.com.cn/config/app 的 endpoint.graphql
 *     就明文下发同一串,任何人可取;各环境同值(测试环境已实调验证)。
 *  2. 生产域名必须用 **pigeon.ihealthlabs.com.cn**。utils/log.js 里那个
 *     pigeon.ihealthcn.com 只放通了 /needleLog 之类的 REST 路径,
 *     打 /${SECRET} 实测返回 nginx 404。
 *
 * 接口本身无需登录(pigeon 侧 getSharedVideoInfo 在鉴权白名单里),CORS 已放通
 * (预检 204 + Access-Control-Allow-Origin 回显本站域名,两个环境都实测过)。
 */
const PIGEON_GRAPHQL_PATH = '8B8kMWAunyMhxM9q9OhMVCJiXpxBIqpo'

export const getPigeonGraphqlUrl = () => {
  const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
  const isTest = host.indexOf('h5-blogs-test') > -1 || host.indexOf('h5-blogs-dev') > -1 || host === 'localhost' || host === '127.0.0.1'
  const base = isTest ? 'https://pigeon-test.ihealthcn.com' : 'https://pigeon.ihealthlabs.com.cn'
  return `${base}/${PIGEON_GRAPHQL_PATH}`
}

const GET_SHARED_VIDEO_INFO = `
  query getSharedVideoInfo($videoId: ID!) {
    getSharedVideoInfo(videoId: $videoId) {
      success
      message
      # 失效原因:NOT_FOUND / OFFLINE / SHARE_DISABLED / NO_VIDEO_SOURCE。
      # 眼下四种都显示同一句 message(产品口径),取回来是为了将来产品要区分
      # 「已下架」和「链接无效」时只改这边的渲染,不用再动后端。
      reason
      data {
        _id
        title
        desc
        videoUrl
        avatar
        votes
        author {
          nickname
          avatar
          authorTitle
        }
      }
    }
  }
`

/**
 * @returns {Promise<{success:boolean, message:string, reason:string, data:object|null}>}
 * 网络/服务异常也归一成失效态,让页面只有"能看"和"看不了"两种形态。
 * 这类"没拿到应答"的失效 reason 记 NETWORK,与后端给的四种业务原因区分开。
 */
export const fetchSharedVideoInfo = async videoId => {
  try {
    const res = await axios.post(
      getPigeonGraphqlUrl(),
      { query: GET_SHARED_VIDEO_INFO, variables: { videoId } },
      { headers: { 'Content-Type': 'application/json' }, timeout: 15000 }
    )
    const payload = res && res.data && res.data.data && res.data.data.getSharedVideoInfo
    if (!payload) {
      return { success: false, message: '', reason: 'NETWORK', data: null }
    }
    return payload
  } catch (e) {
    return { success: false, message: '', reason: 'NETWORK', data: null }
  }
}



// WEBPACK FOOTER //
// ./src/modules/videoShare/actions/queries.js